export default {
  'SLModal.default.okText': 'Complete',
  'SLModal.default.cacelText': 'Cancel',
  'SLModal.info.okText': 'Got it',
  'SLPopconfirm.cancelText': 'Cancel',
  'SLPopconfirm.okText': 'Confirm',
  'SLModal.danger.okText': 'Delete',
  'SLUpload.default.image.addImage': 'Add Image',
  'SLUpload.default.image.restImages': 'View {{len}} more image',
  'SLUpload.default.image.loading': 'Uploading...',
  'SLUpload.default.image.fail': 'Something went wrong, try upload again.',
  'SLUpload.default.image.delete.title': 'Delete image?',
  'SLUpload.default.image.delete.content': 'This can’t be undone.',
  'SLUpload.ALTFormModal.placeholder': 'Add alt text',
  'SLUpload.ALTFormModal.tip': "Alt text improves SEO and accessibility for people who can't see images on web pages.",
  'SLUpload.ALTFormModal.title': 'Edit alt text',
  'SLUpload.ALTFormModal.length': 'Enter fewer than {{max}} characters',
  'SLUpload.uploadfile.fail': 'Failed to upload',
  'SLUpload.uploadfile.fail1': 'Unsupported file type',
  'SLUpload.uploadfile.sucess': 'Uploaded successfully',
  'SLUpload.uploadfile.text1': 'Upload file',
  'SLUpload.uploadfile.text2': 'Upload files ending in .xlsx .xls.csv',
  'SLUpload.uploadfile.progress': 'Uploading...',
  'SLUpload.dragUploading': 'Drop to upload',
  'SLUpload.default.image.description': 'Recommend size 256 x 116',
  'SLUpload.default.image.fail.title': 'Failed to upload {{fileName}}',
  'SLUpload.default.image.fail.desc1': 'Upload less than {{max}} MB image',
  'SLUpload.default.image.fail.desc2': 'Enter fewer than {{max}} characters',
  'SLUpload.default.image.fail.desc3': 'Upload less than {{limitPx}} MB file',
  'SLUpload.default.image.fail.desc4': 'Sorry, you can upload {{maxNum}} images at most',
  'SLUpload.uploadField.errorMsg4': 'Failed to upload image',
  'SLUpload.uploadField.upload': 'Upload image',
  'SLUpload.SLImage.preview.closeText': 'Close'
};